import { Box, Stack, Typography, useTheme } from "@mui/material";
import React from "react";
import Logo from "./Logo";
import FacebookIcon from "../images/fb.svg";
import TwitterIcon from "../images/twit.svg";
import LinkedInIcon from "../images/linkedin.svg";
import GitHubIcon from "../images/github.svg";
import RssIcon from "../images/rss.svg";
import QueryPreservingLink from "../components/QueryPreservingLink";

const menu1 = [
  { name: "Home", url: "/" },
  { name: "Community", url: "/community" },
  { name: "DN Research Program", url: "/programs/research" },
  { name: "Panel Program", url: "/programs/panel" },
  { name: "Blog", url: "/blog" },
];

const menu2 = [
  { name: "Knowledge Hub", url: "/resources/knowledge" },
  { name: "Pulse Report", url: "/developer-reports" },
  /* { name: 'Trends', url: '/resources/graphs' }, */
  { name: "Reports", url: "/resources/reports" },
  { name: "Forum", url: "https://forum.developernation.net/" },
  {
    name: "Events",
    url: "https://forum.developernation.net/c/events-and-meet-ups/13",
  },
  { name: "Podcast", url: "/podcast" },
];

const menu3 = [
  { name: "Referrers", url: "/survey/referrer" },
  { name: "Partners", url: "/survey/partner" },
  { name: "Affiliates", url: "/survey/affiliate" },
];

const social = [
  {
    url: `https://www.facebook.com/${process.env.GATSBY_FACEBOOK_ACCOUNT_NAME}`,
    icon: FacebookIcon,
    alt: "facebook",
  },
  {
    url: `https://twitter.com/${process.env.GATSBY_TWITTER_ACCOUNT_NAME}`,
    icon: TwitterIcon,
    alt: "twitter",
  },
  {
    url: `https://www.linkedin.com/company/${process.env.GATSBY_LINKEDIN_ACCOUNT_NAME}`,
    icon: LinkedInIcon,
    alt: "linkedin",
  },
  {
    url: `https://github.com/${process.env.GATSBY_GITHUB_ACCOUNT_NAME}`,
    icon: GitHubIcon,
    alt: "Github",
  },
  {
    url: `/rss.xml`,
    icon: RssIcon,
    alt: "Rss Feed",
  },
];

const Footer = () => {
  const theme = useTheme();

  return (
    <Stack sx={{ px: { xs: "40px", lg: "100px" }, pt: "40px", pb: "16px" }}>
      <Stack
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
        direction={{ xs: "column", md: "row" }}
        gap={2}
      >
        <Stack sx={{ alignItems: { xs: "center", md: "start" } }}>
          <Box
            compontent="a"
            href={process.env.GATSBY_SLASHDATA_SITE_NAME}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ marginBottom: "12px!important" }}
          >
            <Logo />
          </Box>

          <Typography
            variant="body2"
            sx={{ fontWeight: "bold" }}
            color="primary"
          >
            Contact us
          </Typography>

          <Typography variant="caption" color="primary">
            Swan Buildings (1st floor)
          </Typography>

          <Typography variant="caption" color="primary">
            20 Swan Street
          </Typography>

          <Typography variant="caption" color="primary">
            Manchester, M4 5JW
          </Typography>

          <Typography variant="caption" color="primary">
            +441612400603
          </Typography>

          <Typography variant="caption" color="primary">
            community@developernation.net
          </Typography>
        </Stack>

        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={{ alignItems: { xs: "center", md: "start" } }}
          gap={{ xs: 1, md: 4, lg: 6 }}
        >
          <Stack sx={{ alignItems: { xs: "center", md: "start" } }}>
            {menu1.map((item, index) => (
              <Typography
                component={QueryPreservingLink}
                to={item.url}
                key={index}
                sx={{
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
                variant="body2"
                color="primary"
              >
                {item.name}
              </Typography>
            ))}
          </Stack>

          <Stack sx={{ alignItems: { xs: "center", md: "start" } }}>
            <Typography
              sx={{
                textDecoration: "none",
                mb: "4px",
              }}
              variant="body2"
              color="primary"
            >
              Resources
            </Typography>

            {menu2.map((item, index) =>
              item.url.includes("https://") ? (
                <Box
                  component="a"
                  key={index}
                  href={item.url}
                  sx={{
                    textDecoration: "none",
                    fontWeight: "bold",
                    color: theme.palette.primary.main,
                    fontSize: "14px",
                  }}
                >
                  {item.name}
                </Box>
              ) : (
                <Typography
                  component={QueryPreservingLink}
                  to={item.url}
                  key={index}
                  sx={{
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                  variant="body2"
                  color="primary"
                >
                  {item.name}
                </Typography>
              )
            )}
          </Stack>

          <Stack sx={{ alignItems: { xs: "center", md: "start" } }}>
            <Typography
              sx={{
                textDecoration: "none",
                mb: "4px",
              }}
              variant="body2"
              color="primary"
            >
              Partner Network
            </Typography>

            {menu3.map((item, index) => (
              <Typography
                component={QueryPreservingLink}
                to={item.url}
                key={index}
                sx={{
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
                variant="body2"
                color="primary"
              >
                {item.name}
              </Typography>
            ))}
          </Stack>
        </Stack>

        <Stack gap={2}>
          <Stack direction="row" gap={2}>
            {social.map((s, index) => {
              return (
                <Box
                  component="a"
                  href={s.url}
                  target="_black"
                  rel="noopener noreferrer"
                  key={index}
                >
                  <Box
                    component="img"
                    src={s.icon}
                    alt={s.alt}
                    sx={{ height: 24 }}
                  />
                </Box>
              );
            })}
          </Stack>

          <Typography
            component={QueryPreservingLink}
            to="/code-of-conduct"
            sx={{
              textDecoration: "none",
              fontWeight: "bold",
              alignSelf: "center",
            }}
            variant="body2"
            color="primary"
          >
            Code of Conduct
          </Typography>
        </Stack>
      </Stack>

      <Stack
        sx={{
          marginTop: { xs: "20px", md: "50px" },
          alignSelf: "center",
          alignItems: "center",
        }}
      >
        <Stack direction="row" gap={1}>
          <Typography
            variant="caption"
            color="primary"
            sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
          >
            SlashData © Copyright
            {` ${new Date().getFullYear()}`}
          </Typography>

          <Typography variant="caption" color="primary">
            {" "}
            |
          </Typography>

          <Typography
            variant="caption"
            color="primary"
            sx={{ whiteSpace: "nowrap" }}
          >
            All rights reserved
          </Typography>
        </Stack>

        <Stack direction="row" gap={1}>
          <Typography
            variant="caption"
            color="primary"
            component={QueryPreservingLink}
            to="/cookie-policy"
            sx={{ whiteSpace: "nowrap" }}
          >
            Cookie Policy
          </Typography>

          <Typography variant="caption" color="primary">
            {" "}
            |
          </Typography>

          <Typography
            variant="caption"
            color="primary"
            component={QueryPreservingLink}
            to="/privacy"
            sx={{ whiteSpace: "nowrap" }}
          >
            Privacy Policy
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Footer;
